import { __assign, __awaiter, __generator } from "tslib";
import React from 'react';
import { BubbleCommand } from '../../../_shared/constants';
import { BubbleChannel } from '../../../client/src/modules/_core/components/BubbleChannel';
import { removeSessionThreadId } from '../../../client/src/modules/_core/utils/app-storage';
import { alertModal } from '../../../client/src/modules/domain/app-modal';
import { dataLayerPush } from '../../utils';
import { BytesizeIcon } from '../../../client/src/modules/_core/components/BytesizeIcon';
import { elementAttrs } from '../../../client/src/modules/_core/utils/element-id';
import { ChatThreadClass } from '../../../client/src/modules/chat/components/ChatThread/ChatThread';
import { CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES, CUSTOM_MESSAGE_TYPE_MARKER } from '../../../client/src/consts';
import { ChatMessageType } from '../../../client/src/_library/domain-base/BaseChatMessage';
var endOrClose = function () {
    // https://docs.google.com/spreadsheets/d/1WDsoIs_v0Dc1sOASo0k0ugUbb2i7o3QaJj6NyZisKAQ/edit#gid=0
    dataLayerPush({ eventAction: 'UpperCornerClick', eventLabel: 'Close' });
    removeSessionThreadId();
    BubbleChannel.postCommand(BubbleCommand.CLOSE);
};
var CloseModalBody = function (cmp) {
    var props = cmp.props;
    var dispatch = props.dispatch, identity = props.identity;
    var reviewButtonHandler = function (isPositiveFeedback) { return __awaiter(void 0, void 0, void 0, function () {
        var currentConversationalId;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    cmp.handleOK();
                    currentConversationalId = ((_c = (_b = (_a = cmp.props) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.named_entities) === null || _c === void 0 ? void 0 : _c.conversation_id) || '';
                    return [4 /*yield*/, ChatThreadClass.submitMessage({ dispatch: dispatch, identity: identity, threadId: currentConversationalId }, JSON.stringify({
                            type: CUSTOM_MESSAGE_TYPE_MARKER,
                            room: CUSTOM_MESSAGE_ROOM_MARKER__SET_ENTITIES,
                            payload: {
                                is_positive_feedback: isPositiveFeedback,
                            },
                        }), ChatMessageType.HIDDEN)];
                case 1:
                    _d.sent();
                    ChatThreadClass.submitMessage({ dispatch: dispatch, identity: identity, threadId: currentConversationalId }, ':bubble_closed_by_x', ChatMessageType.HIDDEN);
                    endOrClose();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", null,
        React.createElement("button", __assign({}, elementAttrs('close-review', 'positive'), { style: {
                marginRight: '30px',
                border: '5px solid #00008f',
                borderRadius: '5px',
            }, onClick: function () { return reviewButtonHandler(true); } }),
            React.createElement(BytesizeIcon, { name: "thumbs-up", size: "larger", thickness: "bold" })),
        React.createElement("button", __assign({}, elementAttrs('close-review', 'negative'), { style: {
                border: '5px solid #00008f',
                borderRadius: '5px',
            }, onClick: function () { return reviewButtonHandler(false); } }),
            React.createElement(BytesizeIcon, { name: "thumbs-down", size: "larger", thickness: "bold" }))));
};
export var headerOnCloseHandler = function (cmp, intl, force) {
    if (force === void 0) { force = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var dispatch, confirmClose;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch = cmp.props.dispatch;
                    confirmClose = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, alertModal(dispatch, {
                                    title: intl.formatMessage({ id: 'closeModal.title' }),
                                    body: CloseModalBody,
                                    labelOK: intl.formatMessage({ id: 'closeModal.cancel' }),
                                })];
                        });
                    }); };
                    if (force)
                        return [2 /*return*/, endOrClose()];
                    return [4 /*yield*/, confirmClose()];
                case 1:
                    if (_a.sent()) {
                        endOrClose();
                    }
                    return [2 /*return*/];
            }
        });
    });
};
